import { Caption1, makeStyles, tokens } from "@fluentui/react-components";
import { Folder16Regular, FolderAdd16Regular } from "@fluentui/react-icons";
import { formatDateTime, formatEuro } from "../lib/format";
import { oggettoGara, type Gara, type Servizio } from "../data/gare";
import { ScadenzaBadge, ValutazioneBadge } from "./Badges";
import { Codice } from "./Codice";

const useStyles = makeStyles({
  card: {
    display: "flex",
    flexDirection: "column",
    gap: tokens.spacingVerticalXS,
    width: "100%",
    textAlign: "left",
    padding: tokens.spacingHorizontalM,
    borderRadius: tokens.borderRadiusLarge,
    border: `1px solid ${tokens.colorNeutralStroke2}`,
    backgroundColor: tokens.colorNeutralBackground1,
    color: tokens.colorNeutralForeground1,
    fontFamily: "inherit",
    fontSize: tokens.fontSizeBase300,
    cursor: "pointer",
    ":hover": { backgroundColor: tokens.colorNeutralBackground1Hover },
    ":focus-visible": { outline: `2px solid ${tokens.colorStrokeFocus2}` },
  },
  top: { display: "flex", alignItems: "center", gap: tokens.spacingHorizontalS, flexWrap: "wrap" },
  codice: { fontWeight: tokens.fontWeightSemibold, fontVariantNumeric: "tabular-nums", overflowWrap: "anywhere" },
  sigla: { color: tokens.colorNeutralForeground3 },
  spacer: { flexGrow: 1 },
  oggetto: { fontWeight: tokens.fontWeightSemibold, lineHeight: tokens.lineHeightBase300 },
  meta: { color: tokens.colorNeutralForeground3, display: "flex", gap: tokens.spacingHorizontalM, flexWrap: "wrap", alignItems: "center" },
  cartella: { display: "inline-flex", alignItems: "center", gap: "4px" },
  daCreare: { display: "inline-flex", alignItems: "center", gap: "4px", color: tokens.colorPaletteMarigoldForeground1 },
});

export function GaraCard({ g, servizio, onOpen }: { g: Gara; servizio?: Servizio; onOpen: () => void }) {
  const s = useStyles();
  const f = g.fields;
  const partecipa = f.Valutazione === "Partecipa";
  return (
    <button type="button" className={s.card} onClick={onOpen}>
      <div className={s.top}>
        <span className={s.codice}>
          <Codice value={f.Codice} />
        </span>
        <span className={s.spacer} />
        <ValutazioneBadge g={g} />
        <ScadenzaBadge g={g} />
      </div>
      <div className={s.oggetto}>{oggettoGara(g)}</div>
      <Caption1 className={s.meta}>
        <span>{f.Stazione}</span>
        {f.Scadenza && <span>Scadenza {formatDateTime(f.Scadenza)}</span>}
        {f.Importo != null && <span>{formatEuro(f.Importo)}</span>}
        {f.PerLotti && <span>A lotti</span>}
        {f.CartellaId ? (
          <span className={s.cartella}>
            <Folder16Regular /> Cartelle create
          </span>
        ) : partecipa ? (
          <span className={s.daCreare}>
            <FolderAdd16Regular /> {f.PosizioneId ? "Creazione da completare" : "Cartelle da creare"}
          </span>
        ) : null}
      </Caption1>
    </button>
  );
}
